import SunAccent from "@/components/feature/SunAccent";
import { Link } from "react-router-dom";
import { brand } from "@/mocks/siteData";

export default function ContactHero() {
  return (
    <section className="relative min-h-[62vh] flex flex-col justify-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fresh%20welcoming%20South%20Indian%20farmer%20smiling%20while%20speaking%20on%20a%20phone%20in%20front%20of%20a%20green%20paddy%20field%2C%20soft%20natural%20light%2C%20painterly%20stylized%20earthy%20tones%2C%20friendly%20rural%20hospitality%20mood%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1920&height=1080&seq=contact-hero&orientation=landscape"
          width={1920}
          height={1080}
          alt="Friendly farmer welcoming visitors to the farm"
          title="Contact Rythugaru agri tourism"
          className="w-full h-full object-cover object-top"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-32 pb-12 md:pb-16">
        <nav className="flex items-center gap-2 text-xs md:text-sm text-background-200 mb-6 flex-wrap">
          <Link to="/" className="hover:text-background-50 transition-colors">
            Home
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-background-50">Contact</span>
        </nav>

        <div className="flex items-center gap-3 mb-5">
          <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-400"></span>
          <span className="text-xs font-semibold tracking-[0.28em] uppercase text-accent-300">
            Get in Touch
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl leading-[1.05] text-background-50 font-semibold max-w-3xl">
          Let's Plan Something <span className="italic text-accent-300">Worth Remembering.</span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-background-100 leading-relaxed max-w-2xl">
          Whether you're a family, a school, a company or a curious traveller, our team is here to
          help you pick the right experience and plan the perfect visit to Konaseema.
        </p>

        <div className="flex flex-wrap gap-x-8 gap-y-4 mt-10">
          <a
            href={`tel:${brand.phone}`}
            className="flex items-center gap-3 text-background-100 hover:text-background-50 transition-colors cursor-pointer"
          >
            <span className="w-11 h-11 flex items-center justify-center rounded-full bg-background-50/15 border border-background-50/30 shrink-0">
              <i className="ri-phone-line text-xl"></i>
            </span>
            <span className="text-sm font-semibold">{brand.phone}</span>
          </a>
          <a
            href={`mailto:${brand.email}`}
            className="flex items-center gap-3 text-background-100 hover:text-background-50 transition-colors cursor-pointer"
          >
            <span className="w-11 h-11 flex items-center justify-center rounded-full bg-background-50/15 border border-background-50/30 shrink-0">
              <i className="ri-mail-line text-xl"></i>
            </span>
            <span className="text-sm font-semibold">{brand.email}</span>
          </a>
        </div>
      </div>
    </section>
  );
}